import { walletKey } from '../../lib/walletKey.js';
import { chainsForNamespace, fetchWallets } from './api.js';
import { mapWallet } from './mapWallet.js';
import { SLUGS_TO_FILTER } from '../../constants.js';
export const WALLET_REGISTRY_BATCH_LIMIT = 100;
const SNAPSHOT_NAMESPACES = ['eip155', 'solana'];
const SNAPSHOT_PAGE_SIZE = 100;
export async function fetchRegistrySnapshot(projectId) {
    const fetchPage = (namespace, page) => fetchWallets({ page, entries: SNAPSHOT_PAGE_SIZE, chains: chainsForNamespace(namespace), projectId });
    const firstPages = await Promise.all(SNAPSHOT_NAMESPACES.map(namespace => fetchPage(namespace, 1)));
    const remainingPages = await Promise.all(SNAPSHOT_NAMESPACES.flatMap((namespace, i) => {
        const pageCount = Math.ceil(firstPages[i].count / SNAPSHOT_PAGE_SIZE);
        return Array.from({ length: Math.max(pageCount - 1, 0) }, (_, index) => fetchPage(namespace, index + 2));
    }));
    const seen = new Set();
    const wallets = [];
    for (const page of [...firstPages, ...remainingPages]) {
        for (const wallet of page.data) {
            if (seen.has(wallet.id))
                continue;
            seen.add(wallet.id);
            wallets.push(wallet);
        }
    }
    return wallets;
}
export function normalizeRegistryNames(names) {
    return [...new Set(names.map(name => walletKey(name)).filter(Boolean))];
}
export function matchRegistrySnapshot(snapshot, keys, projectId) {
    const unmatched = new Set(keys);
    const matches = [];
    for (const wallet of snapshot) {
        if (!unmatched.size)
            break;
        const mapped = mapWallet(wallet, projectId);
        if (SLUGS_TO_FILTER.includes(mapped.id))
            continue;
        const matchedKeys = [walletKey(mapped.name), walletKey(mapped.id)].filter(key => unmatched.has(key));
        if (!matchedKeys.length)
            continue;
        for (const key of matchedKeys)
            unmatched.delete(key);
        matches.push(wallet);
    }
    return matches;
}
